import React, { useState } from 'react';
import { Button, Dialog, Icon, Label, Text } from 'components';
import { RESET_MFA_MUTATION } from 'gql';
import { useMutation } from '@apollo/client';
import { useModal } from 'providers/modalProvider';
import { useIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

const ResetMFA = () => {
  const { formatMessage } = useIntl();
  const { modalDispatch, modalState } = useModal();
  const [screenContent, setScreenContent] = useState('MAIN');
  const modalBody = {
    MAIN: (
      <Text variant="body1" data-testid="resetMfa-main-content">
        <FormattedMessage id="containers.users.modals.resetMFA.main" />
      </Text>
    ),
    SUCCESS: (
      <div
        className={classNames(['flex', 'gap-8'])}
        data-testid="resetMfa-success-content"
      >
        <Icon customIcon="vector" />
        <Text variant="body1">
          <FormattedMessage id="containers.users.modals.resetMFA.success" />
        </Text>
      </div>
    ),
    ERROR: (
      <div
        className={classNames(['flex', 'gap-8'])}
        data-testid="resetMfa-error-content"
      >
        <Icon customIcon="warning" />
        <Text variant="body1">
          <FormattedMessage id="containers.users.modals.resetMFA.error" />
        </Text>
      </div>
    ),
  };
  const [resetMfaMutation, { loading }] = useMutation(RESET_MFA_MUTATION, {
    onError: () => setScreenContent('ERROR'),
    onCompleted: () => setScreenContent('SUCCESS'),
  });
  const resetMfa = () => {
    const { user = {} } = modalState;
    const { id: userId, squad } = user;
    return resetMfaMutation({
      variables: {
        input: {
          userId,
          squadId: squad?.id || modalState?.squad?.id || undefined,
        },
      },
    });
  };
  const modalFooter = {
    MAIN: (
      <>
        <Button
          outlined
          text={formatMessage({ id: 'containers.all.btn.cancel' })}
          intent="Primary"
          onClick={() => modalDispatch({ type: 'ClOSE_ALL' })}
          data-testid="cancel-button-footer"
        />
        <Button
          intent="Primary"
          text={formatMessage({ id: 'containers.all.btn.reset' })}
          onClick={resetMfa}
          loading={loading}
          data-testid="resetMfa-reset"
        />
      </>
    ),
    SUCCESS: (
      <Button
        text={formatMessage({ id: 'containers.all.close' })}
        intent="Primary"
        onClick={() => modalDispatch({ type: 'ClOSE_ALL' })}
        data-testid="resetMfa-success-footer"
      />
    ),
    ERROR: (
      <Button
        text={formatMessage({ id: 'containers.all.btn.tryAgain' })}
        intent="Primary"
        onClick={resetMfa}
        loading={loading}
        data-testid="resetMfa-error-footer"
      />
    ),
  };
  return (
    <Dialog
      dialogTitle={
        <FormattedMessage id="containers.users.modals.resetMFA.title" />
      }
      width="459px"
      icon={
        <span className="bg-resetMfa" size={20} data-testid="bg-resetMfa" />
      }
    >
      <div className="reset-container" data-testid="resetMfa-body">
        {modalBody[screenContent]}
        <Label
          variant="AvatarLabel"
          labelText={`${modalState?.user?.firstName} ${
            modalState?.user?.middleName || ''
          } ${modalState?.user?.lastName}`}
          avatarText={`${modalState?.user?.firstName} ${modalState?.user?.lastName}`}
          data-testid="resetMfa-avatarLabel"
        />
      </div>
      <div className="bp3-dialog-footer" data-testid="resetMfa-footer">
        <div className="bp3-dialog-footer-actions">
          {modalFooter[screenContent]}
        </div>
      </div>
    </Dialog>
  );
};

export default ResetMFA;
